import ga from "@starter/Framework/Common/GoogleAnalytics";

const mapCartOption = (options: Toolkit.GoogleAnalytics.Options | undefined): Toolkit.GoogleAnalytics.Event => {
    if (!options?.cart) {
        return {};
    }

    const { cart } = options;

    return {
        ...ga.map.promotionsOption(options),
        has_notes: Boolean(cart.notes),
        item_list_id: cart.id,
        items: !options?.skipOptionItems ? ga.map.items(cart.cartLines) : undefined,
        payment_type: cart.paymentMethod?.name,
        shipping: cart.shippingAndHandling,
        shipping_tier: cart.shipVia?.description,
        tax: cart.totalTax,
        transaction_id: cart.erpOrderNumber || cart.orderNumber,
        value: cart.orderGrandTotal,
    };
};

export default mapCartOption;
